import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect, Fragment } from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button, Divider, ListItem, ListItemText, List, AppBar, Toolbar, IconButton, Typography, Container, Grid } from "@material-ui/core";

import { DialogContentText, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core'
import TextField from '@material-ui/core/TextField';

import Box from '@material-ui/core/Box';

import { member as v_member, basic, Values, SNACKBAR_TIME } from '../request/values';

import ToastStr from '../request/toastStr';
import { useSnackbar } from 'notistack';

import { COLORS } from './Theme'
import axios from "axios";
import { SIcon } from "./Icon";
import { DialogConfirm, DialogInput } from "./Dialog";
import { useHistory } from "react-router-dom";
import { TitleBackBar } from "./header/TitleBar";
import NumberFormat from "react-number-format";
import { TurnedIn } from "@material-ui/icons";
import { Toast } from "react-bootstrap";


const SERVER = basic.server;

const useStyles = makeStyles({
    container: {
        padding: 0,
        height: '88vh',
        width: '84vw',
        paddingTop: '1.5vh',
        background: `${COLORS.WHITE}`,
    },

    toolBar: {
        padding: 0,
    },
    back: {
        float: 'left',
        width: '10%',
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        float: 'left',
        textAlign: 'center',
        width: '80%',
        justifyContent: 'center',
        "& img": {
            width: '6.5vw',
            height: '6.5vw',
        }
    },
    titleIcon: {
        width: 30,
        height: 30,
    },
    title: {
        fontSize: '6.5vw',
        fontWeight: 'bold',
        color: `${COLORS.WATER_BLUE}`,
        marginLeft: '2vw',
        // marginBottom: '0.5vh',
        // alignItems: 'center',
        // flexGrow: 1,
        // textAlign: 'center',
    },

    buttonSection: {
        textAlign: 'center',
        marginTop: '2vh',
        marginBottom: '1.5vh',
    },
    button: {
        width: '83vw',
        height: '6vh',
        fontSize: '4vw',
        fontFamily: 'NanumB',
        fontWeight: 'bold',

        borderRadius: '24px',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        // border: 'solid 0.5px #cfd4d9',
    },



    table: {
        minWidth: 650,
    },
    tableCol1: {
        maxWidth: 150,
    },
    LoanTable: {
        width: '100%',
        height: '62vh',
        // maxHeight: '62vh',
        overflowY: 'auto',
        '& li': {
            backgroundColor: `${COLORS.LIGHT_GREY}`,
            borderRadius: 12,
            border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
            marginBottom: '1.5vh',
            fontSize: '3.5vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`
        }
    },

    tableText: {
        width: '100%',
        fontSize: '3.5vw',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        color: `${COLORS.BROWNISH_GREY}`,
        borderColor: `${COLORS.BROWNISH_GREY}`,
        '& th, td': {
            padding: 7,
            fontSize: '3.5vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },

    loanButton: {
        display: 'flex',
        flex: 1,
        "& button": {
            borderRadius: '8.5px',
            fontSize: '4.2vw',
            width: '38vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            margin: '1.5vw',
        },

    },

    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        "& img": {
            width: "35vw",
            height: '35vw',
            marginBottom: '2.5vh',
        },
        "& h1": {
            color: `${COLORS.DOWN}`,
        }

    },

    loan: {
        width: '80vw',
        height: '30vw',
    },

    divider: {
        padding:'2.5vh',
    },


})


type iLoanList = {
    loanNum: string,
    loanInterest: number,
    loanDate: string,
    totalPrice: number,
    payback: string,
    materialName: string,
    materialCount: number,
}

const MaterialLoan: React.FC<any> = props => {
    const classes = useStyles();

    const { member } = props;
    let history = useHistory()
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [loanList, setLoanList] = useState<iLoanList[]>([]);
    const [input, setInput] = useState<boolean>(false);
    // 0 = close, 1 = 요청 , 2 = 확인
    const [confirm, setConfirm] = useState<number>(0);
    const [left, setLeft] = useState<number | null>(); //상환하지 않은 재료 갯수
    const [indexNum, setIndexNum] = useState<string | null>();


    const getLoanList = () => {
        let url = new URL(SERVER + v_member.member + v_member.material_loan_list);
        let params = { 'companyNum': member.companyNum, 'classCode': member.classCode }
        url.search = new URLSearchParams(params).toString();

        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
        })
        .then(res => res.data)
        .then((data) => {
            console.log('res data : ', data, data.loanList.length);
            if (data.code === Values.SUCCESS_CODE) {
                setLoanList(data.loanList)
            }
        })
    }

    const getMaterialLoanStatus = (index: any) =>{
        let url = new URL(SERVER + v_member.member + v_member.material_loan_status);
        let param = {'materialLoanNum': loanList[index].loanNum}
        url.search = new URLSearchParams(param).toString();
        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
        })
        .then(res=> res.data)
        .then((data)=>{
            if(data.code === Values.SUCCESS_CODE){
                console.log('res data : ',data);
                setIndexNum(indexNum => index)
                setLeft(left => data.status)
            }
        })
    }

    const postPayBack = (indexNum: any) => {
        console.log(indexNum)
        axios({
            method: "POST",
            data: {
                materialLoanNum: loanList[indexNum].loanNum,
                //loanInterest: loanList[indexNum].loanInterest,
                companyNum: member.companyNum,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.material_loan_payback,
        }).then((res) => {
            return res.data
        }).then((data: any) => {
            console.log(data)
            if (data.code === Values.SUCCESS_CODE) {
                enqueueSnackbar(ToastStr.MATERIAL_LOAN_APPROVAL_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                getLoanList()
            }else if(data.code === Values.CLASS_STOCK_INSUFFICIENT_CODE){
                enqueueSnackbar(ToastStr.COMPANY_STOCK_INSUFFICIENT_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })  
            }else if (data.code === Values.FAIL_CODE) {
                enqueueSnackbar(ToastStr.MATERIAL_LOAN_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
            } else {
                enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
            }
        })
    }

    useEffect(() => {
        getLoanList()
    }, [])

    const goInfoPage = (index: any) => {
        if (index >= 0) {
            history.push({
                //Modify this part
                pathname: '/materialLoanSheet/' + loanList[index].loanNum,
                state: {  // location state
                    loan: loanList[index]
                },
            });
        }
    }

    useEffect(()=>{
        console.log(left)
        if(left != null){
            if(left > 0)
                enqueueSnackbar(ToastStr.MATERIAL_LOAN_LEFT, {variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no"})
            else if(left === 0)
                postPayBack(indexNum)
        }
        setLeft(null)
    }, [left])

    const payBack = (index: any) => {
        console.log(loanList[index].loanNum)
        if (index >= 0)
            getMaterialLoanStatus(index);
    }

    return (
        <Container component="main" className={classes.container} translate = "no">

            <TitleBackBar history={history} title="재료대출현황" titleIcon="order" />
            <Typography variant="h1" align='center' style={{ color: `${COLORS.BROWNISH_GREY}` }}>창을 누르시면 더 자세한 재료대출내역을 알 수 있습니다.</Typography>

            {loanList.length != 0 ?
                <List className={classes.LoanTable}>
                    {loanList.map((item: any, index: number) => {
                        return <LoanItem item={item}
                            payback={(e:any) => {
                                //setConfirm(1)
                                payBack(index)
                            }}
                            infoPage = {(e:any) => {goInfoPage(index)}}
                        />
                    })}
                </List>

                : <div className={classes.empty}>
                    <div>
                        <img src="/images/empty_loan.webp" />
                        <Typography variant="h1">대출한 내역이 없습니다.</Typography>
                    </div>
                </div>}
        </Container>
    )
}

const LoanItem: React.FC<any> = (props) => {
    const classes = useStyles();
    const { item, payback, infoPage } = props;

    const click = () => {
        console.log('click', item.payback)
        if (item.payback !== 'complete') {
            payback();
        }

    }

    const goInfoPage = () => {
        infoPage();
    }

    return (
        <ListItem translate = "no">
            <Grid container>
                <Grid >
                    <TableContainer component={Paper} style={{ boxShadow: 'none', backgroundColor: `${COLORS.LIGHT_GREY}`, width:'75vw'}}>
                        <Table>
                            <TableBody>
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ borderBottom: "none", paddingLeft: 0 }} component="th" scope="row">
                                        대출재료명
                                    </TableCell>
                                    <TableCell align="right" style={{ fontSize: '3vw', borderBottom: "none", paddingLeft: 0 }} component="th" scope="row">
                                        {item.loanDate.substring(11, 16)}
                                    </TableCell>
                                </TableRow>
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ paddingTop:0, borderBottom: "none" }}>
                                        <Typography>{item.materialName} 외 {item.materialCount} 건</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ borderBottom: "none", paddingLeft: 0 }} component="th" scope="row">
                                        잔여 금액
                                    </TableCell>
                                    <TableCell align="right" style={{ borderBottom: "none" }}>
                                        <NumberFormat value={item.totalPrice} displayType={'text'} thousandSeparator={true} suffix="원" />
                                    </TableCell>
                                </TableRow>
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ borderBottom: "none", paddingLeft: 0 }} component="th" scope="row">
                                        대출 이자
                                    </TableCell>
                                    <TableCell align="right" style={{ borderBottom: "none", fontSize: '3.5vw', color: `${COLORS.PUMPKIN}` }}>
                                        <NumberFormat value={item.loanInterest} displayType={'text'} thousandSeparator={true} suffix="원" />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid container alignItems="center" style={{ justifyContent: "space-around" }} >
                    <Grid item>
                        <div className={classes.loanButton}>
                            <div>
                                {item.payback === 'complete'
                                    ? <Button disabled style={{ backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`, color: `${COLORS.WHITE}` }}>상환완료</Button>
                                    : <Button onClick={() => click()} style={{ backgroundColor: `${COLORS.WATER_BLUE}`, color: `${COLORS.WHITE}` }}>상환하기</Button>
                                }
                            </div>
                            <div>
                                <Button onClick={() => goInfoPage()} style={{ backgroundColor: `${COLORS.WATER_BLUE}`, color: `${COLORS.WHITE}` }}>상세보기</Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

        </ListItem>
    )
}

export default MaterialLoan;